import colorResources from '../resources/colors';
import styleVariables from '../scss/variables/_colors.scss';

export default {
	daysOfWeek: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
	daysShort: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
	monthNames: [
		'Январь',
		'Февраль',
		'Марш',
		'Апрель',
		'Май',
		'Июнь',
		'Июль',
		'Август',
		'Сентябрь',
		'Октября',
		'Ноябрь',
		'Декабрь',
	],
	texts: {
		apply: 'Применить',
		cancel: 'Отменить',
		keyboardShortcuts: 'Клавиатурная',
	},
	ariaLabels: {
		chooseDate: (date) => date,
		chooseStartDate: (date) => `Choose ${date} as your start date.`,
		chooseEndDate: (date) => `Choose ${date} as your end date.`,
		selectedDate: (date) => `Selected. ${date}`,
		unavailableDate: (date) => `Not available. ${date}`,
		previousMonth: 'Move backward to switch to the previous month.',
		nextMonth: 'Move forward to switch to the next month.',
		closeDatepicker: 'Close calendar',
		openKeyboardShortcutsMenu: 'Open keyboard shortcuts menu.',
		closeKeyboardShortcutsMenu: 'Close keyboard shortcuts menu'
	},
	keyboardShortcuts: [
		{symbol: '↵', label: 'Select the date in focus', symbolDescription: 'Enter key'},
		{symbol: '←/→', label: 'Move backward (left) and forward (down) by one day.', symbolDescription: 'Left or right arrow keys'},
		{symbol: '↑/↓', label: 'Move backward (up) and forward (down) by one week.', symbolDescription: 'Up or down arrow keys'},
		{symbol: 'PgUp/PgDn', label: 'Switch months.', symbolDescription: 'PageUp and PageDown keys'},
		{symbol: 'Home/End', label: 'Go to the first or last day of a week.', symbolDescription: 'Home or End keys'},
		{symbol: 'Esc', label: 'Close this panel', symbolDescription: 'Escape key'},
		{symbol: '?', label: 'Open this panel', symbolDescription: 'Question mark'}
	],
	colors: {
		selected: colorResources.orange,
		inRange: colorResources.yellow,
		selectedText: styleVariables.white,
		text: styleVariables['gray-500'],
		inRangeBorder: colorResources.yellow,
		disabled: styleVariables['gray-200'],
	}
};